var exports = {
  "w": "x31de4314--a078c0--header",
};

module.exports = exports;
